// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.line__sIvKgJlQGs{padding:var(--dixa-size-spacer-300) 0}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/sidebar/cards/historyCard/historyCardItem/historyCardItem.module.scss"],"names":[],"mappings":"AAEA,kBACE,qCAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.line {\n  padding: var(--dixa-size-spacer-300) 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"line": `line__sIvKgJlQGs`
};
export default ___CSS_LOADER_EXPORT___;
